import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import '../../styles/Login.css';
import Logo from '../../assets/images/logo.png';
import { API_URL } from '../../app/constants'
import {
  Box,
  Container,
  Typography,
  Button,
  CssBaseline,
  styled
} from '@mui/material';

const MainContainer = styled(Box)({
  minHeight: '100vh',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Manrope, sans-serif',
  padding: '20px',
  '@media (min-width: 769px)': {
    alignItems: 'flex-start',
    paddingTop: '120px',
  },
  '@media (max-width: 768px)': {
    alignItems: 'flex-start',
    paddingTop: '120px',
    padding: '120px 20px 40px',
  },
});

const StyledContainer = styled(Container)({
  maxWidth: '700px',
  width: '700px',
  fontFamily: 'Manrope, sans-serif',
});

const StartButton = styled(Button)(({ disabled }) => ({
  width: '100%',
  marginTop: '1rem',
  marginBottom: '1rem',
  backgroundColor: disabled ? '#E9D5FF' : '#9333EA',
  color: 'white',
  borderRadius: '4px !important',
  border: '1px solid',
  borderColor: disabled ? '#E9D5FF' : '#9333EA',
  padding: '12px 14px',
  fontWeight: 600,
  fontSize: '15px',
  textTransform: 'none',
  letterSpacing: 0,
  fontFamily: 'Manrope, sans-serif',
  minHeight: '48px',
  boxShadow: 'none !important',
  '&.MuiButton-root': {
    borderRadius: '4px !important',
  },
  '&:hover': {
    backgroundColor: disabled ? '#E9D5FF' : '#7928CA',
    border: '1px solid',
    borderColor: disabled ? '#E9D5FF' : '#7928CA',
    boxShadow: 'none !important',
    borderRadius: '4px !important',
  },
  '&.Mui-disabled': {
    backgroundColor: '#E9D5FF',
    color: '#fff',
    border: '1px solid #E9D5FF',
    borderRadius: '4px !important',
  },
}));

function LevelTestIntro() {
  // const navigate = useNavigate();
  const targetLevel = localStorage.getItem('selectedLevel');
  const [loading, setLoading] = useState(false);

  const handleStartTest = async () => {
    setLoading(true);
    try {
      // Set a flag that onboarding is complete
      localStorage.setItem('onboardingComplete', 'true');
      const jwt = localStorage.getItem('jwt');
      
      // First, update the user's profile with the selected target level
      try {
        // Get the user profile first to maintain existing data
        const userResponse = await fetch(`${API_URL}/api/v1/auth/me`, {
          headers: { 'Authorization': `Bearer ${jwt}` },
          method: "GET"
        });
        
        if (userResponse.ok) {
          // const userData = await userResponse.json();
          
          // Update the profile with target level
          const updateResponse = await fetch(`${API_URL}/api/v1/auth/change-level`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${jwt}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ level: targetLevel })
          });
          
          if (!updateResponse.ok) {
            console.error('Failed to update user profile with target level');
          }
        }
      } catch (updateError) {
        console.error('Error updating user profile:', updateError);
        // Continue with test even if profile update fails
      }
      
      // Now fetch the diagnostic exam for the selected level
      const response = await fetch(`${API_URL}/api/v1/panel/diagnostic-exams/${targetLevel}`, {
        headers: { 'Authorization': `Bearer ${jwt}` }
      });
      const diagnosticExams = await response.json();
      
      if (Array.isArray(diagnosticExams) && diagnosticExams.length > 0) {
        const exam = diagnosticExams[0];
        if (exam.exam_id) {
          // Mark onboarding as fully complete before navigating to diagnostic exam
          localStorage.setItem('onboardingComplete', 'true');
          
          // Force reload to ensure we're using the authenticated routes with sidebar
          window.location.href = `/diagnostic-exam/${exam.exam_id}`;
        } else {
          console.error("Exam ID not found in the response");
        }
      } else {
        console.error("No diagnostic exams found or unexpected response format");
      }
    } catch (error) {
      console.error("Error fetching diagnostic exam:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CssBaseline />
      <Box className="logo-container-box">
        <img src={Logo} alt="Mina Logo" className="mina-logo" />
      </Box>
      <MainContainer>
        <StyledContainer component="main">
          <Typography 
            component="h1" 
            variant="h4" 
            sx={{ 
              textAlign: 'center',
              fontWeight: 700, 
              fontSize: '1.8rem', 
              color: '#111827',
              marginBottom: '32px',
              fontFamily: 'Manrope, sans-serif'
            }}
          >
            Let's start with a level test
          </Typography>
          <Box sx={{ textAlign: 'center', marginBottom: '64px' }}>
            <Typography 
              sx={{ 
                color: '#64748b',
                fontSize: '1rem',
                fontFamily: 'Manrope, sans-serif',
                marginBottom: '16px'
              }}
            >
              The test will take around 8 minutes.
            </Typography>
            <Typography 
              sx={{ 
                color: '#64748b',
                fontSize: '1rem',
                fontFamily: 'Manrope, sans-serif'
              }}
            >
              Your results will help us personalize your learning journey.
            </Typography>
          </Box>
          
          <StartButton
            onClick={handleStartTest}
            disabled={loading}
            disableElevation
          >
            Start Level Test
          </StartButton>
        </StyledContainer>
      </MainContainer>
    </>
  );
}

export default LevelTestIntro;